export default "__VITE_ASSET__CDK1cjMc__ 480w, __VITE_ASSET__VmCw9QD2__ 768w, __VITE_ASSET__D8JT6EAp__ 1200w, __VITE_ASSET__DsKwlEM1__ 1600w";